
import {
    defineComponent,
    inject,
    ref
} from 'vue'

import acrdService from "@/core/services/AcrdService"
import {
    errManager
} from "@/core/config/Tools";
import {
    training,
    condition,
    matricule,
    status
} from "@/core/data/shared"

export default defineComponent({
    props: {
        row: {
            type: Object,
            required: true,
            default: {}
        }
    },
    setup(props) {
        const gblDrawer1 = inject('gblDrawer1')
        const loader = ref(false)
        const url = ref(process.env.VUE_APP_REPO);
        const prt = ref < any > ({})

        const onOpened = async () => {
            loader.value = true
            acrdService.getAcreditation(props.row.idacreditation, 'show')
                .then((res) => {
                    loader.value = false
                    prt.value = res.data
                }).catch(({
                    response
                }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onClosed = async () => {
            prt.value = {}
        }

        return {
            gblDrawer1,
            loader,
            url,
            prt,
            onOpened,
            onClosed,
            training,
            condition,
            matricule,
            status
        }

    },
})
